<template>
  <v-container v-if="user != null">
    <v-card>
      <v-card-title class="headline lighten-2" primary title>{{$t('settings.settings')}}</v-card-title>
      <v-card-text>
        <v-checkbox v-model="customPallets" :label="$t('settings.allow_custom_pallets')" @change="allowCustom($event)"></v-checkbox>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: ['user'],
  data() {
    return {
      customPallets: this.user.company.allow_custom_pallets,
    };
  },
  methods: {
      allowCustom($e){
        this.user.company.save({
          allow_custom_pallets: $e
        });
      }
  }
};
</script>

<style scoped>
</style>